import { render, staticRenderFns } from "./StaffPopup.vue?vue&type=template&id=a68078c2&scoped=true&"
import script from "./StaffPopup.vue?vue&type=script&lang=js&"
export * from "./StaffPopup.vue?vue&type=script&lang=js&"
import style0 from "./StaffPopup.vue?vue&type=style&index=0&id=a68078c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68078c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a68078c2')) {
      api.createRecord('a68078c2', component.options)
    } else {
      api.reload('a68078c2', component.options)
    }
    module.hot.accept("./StaffPopup.vue?vue&type=template&id=a68078c2&scoped=true&", function () {
      api.rerender('a68078c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/StaffPopup.vue"
export default component.exports